// Column.tsx
import { Button } from '@/components/ui/button'
import * as Card from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'
import { AppCollapsible } from '@components'
import { A } from '@solidjs/router'
import { type JSX, type ParentProps, Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'

export default function (
  props: ParentProps<{
    title: string;
    link?: string;
    rightSlot?: JSX.Element;
    isCollapsible?: boolean;
    open?: boolean;           // NEW: Receive open state
    onOpenChange?: any;       // NEW: Receive state updater
  }>,
): JSX.Element {
  return (
    props.isCollapsible ? (
      <Card.Root gridTemplateRows="auto 1fr" display='grid'>
        <AppCollapsible
          open={props.open}
          onOpenChange={props.onOpenChange}
          headerContent={
            <Flex
              justifyContent="space-between"
              alignItems="center"
              height={12}
              p={3}
            >
              <Show
                when={props.link}
                keyed
                fallback={<Heading textStyle="sm">{props.title}</Heading>}
              >
                <A href={props.link!} >
                  <Heading textStyle="sm">{props.title}</Heading>
                </A>
              </Show>
              <Show when={props.rightSlot}>{props.rightSlot}</Show>
            </Flex>
          }>
          {props.children}
        </AppCollapsible>
      </Card.Root >
    ) : (
      <Card.Root gridTemplateRows="auto 1fr" display='grid'>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          height={12}
          p={3}
          borderBottom='solid 1px'
          borderColor='bg.subtle!'
        >
          <Show
            when={props.link}
            keyed
            fallback={<Heading textStyle="sm">{props.title}</Heading>}
          >
            <A href={props.link!} >
              <Heading textStyle="sm">{props.title}</Heading>
            </A>
          </Show>
          <Show when={props.rightSlot}>{props.rightSlot}</Show>
        </Flex>
        {props.children}
      </Card.Root >
    )
  )
}
